export const TK_PREFIX = 'playtech.mobile.';
